import type { NavLink } from "react-router-dom";
import { type Page, Pagetype } from "../../../interfaces/Config";
import { UserType } from "../../../interfaces/User";
import { getUrl } from "../../../utils/dataRetrieval";

export const isStudentDashboardNavActive = (
  pages: Page[],
): Parameters<typeof NavLink>[0]["isActive"] => {
  const page = pages.find((page) => page.type === Pagetype.DASHBOARD);
  if (!page) return undefined;
  return (_, location) => {
    const url = getUrl(page, UserType.Student);
    return location.pathname.replace("/", "").startsWith(url);
  };
};
